import { useMemo, useCallback } from 'react';
import { Checkbox, FormFieldsData, useFormContext } from 'framework/form';
import PeopleManagerDropdown from 'domain/people/employee/shared/input/PeopleManagerDropdown';
import { Box } from '@mui/material';

const PeopleManagementSpecifySection = () => {
  const { data: formData, onChangeCallback, isDirty } = useFormContext();

  const assignedPeopleManagerAliases = useMemo(
    () => formData?.assignedPeopleManagerAliases || [],
    [formData?.assignedPeopleManagerAliases],
  );

  const hasSpecificManagers = useMemo(() => formData?.hasSpecificManagers, [formData?.hasSpecificManagers]);

  const disabledFn = useCallback((data: any) => data?.isAccessForAllPeopleManagers, []);

  const handleCheckboxChange = useCallback(
    (formFields: FormFieldsData) => {
      const { isAccessForAllPeopleManagers } = formFields;
      const specificFlag =
        !isDirty && hasSpecificManagers != null ? hasSpecificManagers : !isAccessForAllPeopleManagers;
      const isAccessForAll = !specificFlag;
      const pplManagers = isAccessForAll ? [] : assignedPeopleManagerAliases;

      if (onChangeCallback) {
        onChangeCallback({
          isAccessForAllPeopleManagers: isAccessForAll,
          hasSpecificManagers: specificFlag,
          assignedPeopleManagerAliases: pplManagers,
        });
      }
    },
    [isDirty, hasSpecificManagers, assignedPeopleManagerAliases, onChangeCallback],
  );

  return (
    <Box display="flex" flexDirection="column">
      <Checkbox
        source="isAccessForAllPeopleManagers"
        label="All people managers will work with the worker"
        onChangeCallback={handleCheckboxChange}
      />
      <PeopleManagerDropdown
        source="assignedPeopleManagerAliases"
        label="People managers"
        multiple
        disabled={disabledFn}
        helpText="If no managers are selected, all people managers will be assigned by default."
      />
    </Box>
  );
};

export default PeopleManagementSpecifySection;
